<router-outlet></router-outlet>

<app-support-widget-fab></app-support-widget-fab>
